var map = {
	"./archive_box_arrow_down.svg": [
		8731,
		112
	],
	"./banknotes.svg": [
		355,
		355
	],
	"./battery_50.svg": [
		8411,
		411
	],
	"./briefcase.svg": [
		8690,
		690
	],
	"./cargo_bulk.svg": [
		3597,
		597
	],
	"./cargo_pallet.svg": [
		9079,
		79
	],
	"./clipboard_document_check.svg": [
		493,
		493
	],
	"./clipboard_document_list.svg": [
		6883,
		883
	],
	"./clock.svg": [
		5708,
		708
	],
	"./credit_card.svg": [
		1674,
		674
	],
	"./document_check.svg": [
		7288,
		288
	],
	"./driving.svg": [
		4379,
		379
	],
	"./exchange_cargo.svg": [
		8200,
		200
	],
	"./exchange_cargo_pl.svg": [
		3731,
		731
	],
	"./exclamation_triangle.svg": [
		8312,
		312
	],
	"./face_frown.svg": [
		5844,
		844
	],
	"./face_smile.svg": [
		8432,
		432
	],
	"./finger_print.svg": [
		8185,
		185
	],
	"./key.svg": [
		51,
		51
	],
	"./leave_for_work.svg": [
		45,
		45
	],
	"./moon.svg": [
		4365,
		365
	],
	"./photo.svg": [
		6278,
		278
	],
	"./prepare_departure.svg": [
		3758,
		758
	],
	"./prepare_to_go_home.svg": [
		6936,
		936
	],
	"./rest.svg": [
		3648,
		648
	],
	"./return_home.svg": [
		1782,
		782
	],
	"./star.svg": [
		1670,
		670
	],
	"./truck.svg": [
		9111,
		111
	],
	"./unload_bulk.svg": [
		7430,
		430
	],
	"./unload_pallet.svg": [
		3872,
		872
	],
	"./user_group.svg": [
		3979,
		979
	],
	"./wait_for_cargo.svg": [
		3620,
		620
	],
	"./wait_for_price_reduction.svg": [
		6737,
		737
	],
	"./walking.svg": [
		4807,
		807
	],
	"./wrench_screwdriver.svg": [
		5482,
		482
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6124;
module.exports = webpackAsyncContext;